module.exports = __webpack_public_path__ + "img/coinbankB19.c5a8d038.jpg";